import * as React from 'react';
import config from '@/server/config';
import request from '@/server/request';

export default class Notification extends React.Component<any, any> {
    private loadTimer: any;
    constructor(props: any) {
        super(props);
        this.state = {
            list: [], // 列表
            page: 1, // 页码
            isLoading: true, // 是否加载中
            loadOver: false, // 是否全部加载完
        };
    }

    public componentDidMount() { 
        this.getData();
        window.addEventListener('scroll', this.scrollAction.bind(this));
    }

    public componentWillUnmount() {
        window.removeEventListener('scroll', this.scrollAction.bind(this));
        if (this.loadTimer) { 
            clearTimeout(this.loadTimer);
        }
        // 卸载异步操作设置状态
        this.setState = (state, callback) => {
            return;
        }
    }

    public render() {
        return (
            <div className="notification">
                {
                    this.state.list.map((v: any, k: number) => { 
                        return (
                            <div className="nitem" key={v.id}>
                                <p className="nitem-time"><span>{v.timeStr}</span></p>
                                <a href={`/mobile/uc/build/notification/detail?id=${v.id}`}>
                                    <div className="nitem-content">
                                        <strong>{v.articleName}</strong>
                                        {
                                            v.picUrl ? <img src={v.picUrl} alt="" /> : null
                                        }
                                        <p>{v.articleSummary}</p>
                                    </div>
                                </a>
                            </div>
                        )
                    })
                }
                <p className="loading-tips">{this.state.loadOver ? '没有更多数据' : '数据加载中...'}</p>
            </div>
        )
    }

    private async getData() { 
        const r = await request({
            url: `${config.API}member/wap/articleList?pageNum=${this.state.page}&pageSize=10`
        });
        if (r.code === 1) { 
            const loadOver = r.obj.pageNum >= r.obj.pages
            this.setState({
                list: [...this.state.list, ...r.obj.list],
                isLoading: false,
                loadOver
            });
        }
    }

    /**
     * 加载更多
     * 滚动加载更多数据
     */
    private scrollAction() {
        if (this.state.isLoading || this.state.loadOver) { 
            return;
        }
        
        if (window.pageYOffset + window.innerHeight + 50 > document.body.scrollHeight) {
            if (this.loadTimer) { 
                clearTimeout(this.loadTimer);
            }
            this.loadTimer = setTimeout(() => {
                this.loadMore();
             }, 500);
        }
    }

    // 加载更多文章内容
    private loadMore() { 
        this.setState({
            isLoading: true,
            page: this.state.page + 1
        }, () => { 
                this.getData();
        });
    }
}